import { render, staticRenderFns } from "./RefundRequestDetail.vue?vue&type=template&id=6cd56a45&"
import script from "./RefundRequestDetail.vue?vue&type=script&lang=js&"
export * from "./RefundRequestDetail.vue?vue&type=script&lang=js&"
import style0 from "./RefundRequestDetail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports